import { Dialog, DialogContent, Grid, IconButton, styled, Typography } from "@mui/material"
import { Box } from "@mui/system"
import React, { useEffect, useState } from "react"
import styles from "../PendingQuestionTable.module.scss"
import CloseIcon from "@mui/icons-material/Close"
import AppButton from "components/StyledComponents/AppButton"
import { useDispatch, useSelector } from "react-redux"
import { Col, Row } from "react-bootstrap"
import Card from "components/Card/Card"
import ImageDisplay from "components/ImageDisplayer"
import classes from "pages/private/marketing/menu/menu.module.scss"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { ReplaceChallengeMenuItemAction, weeklyCategoryAction } from "redux/marketing/actions"
import SubCategoryNavBar from "../components/Navbar/SubCategoryNavBar"
import CategoryNavBar from "../components/Navbar/CategoryNavBar"
import { formateString } from "helpers/functions"
import { learningDevelopmentActions } from "redux/L&D/slice/user"
import { toast } from "react-toastify"

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent"
  }
}))

const SelectMenuItems = ({
  onClose = () => {},
  isGenerateQuestion,
  onSelect,
  onGoToMenu,
  module = "MARKETING"
}) => {
  const isPreshift = module === "PRESHIFT"
  const dispatch = useDispatch()
  const { selectedMenuItems } = useSelector((state) => state?.learningDevelopment || [])
  const [challengeCategoryList, setChallengeCategoryList] = useState([])
  const [selectedChallengeCategory, setSelectedChallengeCategory] = useState({})
  const [subCategoryList, setSubCategoryList] = useState([])
  const [selectedSubCategory, setSelectedSubCategory] = useState([])
  const { weeklyChallengeId, challengeQuestionsCount, weeklyCategoryList } = useSelector(
    (state) => state?.marketing || {}
  )
  const { userRestaurant } = useSelector((store) => store.user)
  const { isLoading } = useSelector((store) => store.app)

  const [selectedItem, setSelectedItem] = useState(isPreshift ? [] : selectedMenuItems || [])
  const categoryName = selectedSubCategory?.category_name
  const isGrouped = categoryName === "Cocktails" || categoryName === "Spirits"

  const renderItemsGrid = (items) => (
    <Grid
      container
      spacing={2}
      justifyContent={items?.length === 0 ? "center" : ""}
      className="mb-4">
      {items?.length > 0 ? (
        items.map((data) => (
          <Grid item xs={4} className={classes.triviaItems} key={data?.id}>
            <div className="d-flex align-items-center">
              <IconButton sx={(theme) => ({ color: theme.palette.secondary.main })}>
                {checkSelected(data?.id) ? (
                  <CheckCircleIcon onClick={() => handleSelect(data)} />
                ) : (
                  <RadioButtonUncheckedIcon onClick={() => handleSelect(data)} />
                )}
              </IconButton>
            </div>
            <div className={classes.imageContainer} style={{ height: 100, width: 100 }}>
              <ImageDisplay data={data?.image} />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                maxWidth: 300,
                overflowWrap: "break-word"
              }}>
              <div className="d-flex justify-content-start align-items-center">
                <Typography variant="h4">{data?.name ?? "-"}</Typography>
              </div>
            </div>
          </Grid>
        ))
      ) : (
        <Typography
          className="mt-4"
          style={{
            opacity: 0.6,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
          {isLoading ? "Please wait, we are fetching the menu items..." : "No Items Found"}
        </Typography>
      )}
    </Grid>
  )

  const renderGroupedItems = (groupItems) =>
    groupItems?.map(
      (item, index) =>
        item?.items?.length > 0 && (
          <Card className="mb-2" key={index}>
            <div className="d-flex justify-content-start align-item-center mb-4">
              <Typography variant="h2">{item?.category_name}</Typography>
              <div className="d-flex align-items-center" />
            </div>
            {renderItemsGrid(item?.items)}
          </Card>
        )
    )

  const checkSelected = (ID) => {
    let isItemSelected = selectedItem.some((item) => item?.id === ID)
    return isItemSelected
  }

  const handleSelect = (data) => {
    const isAvailable = selectedItem.some((item) => item?.id === data?.id)

    if (isAvailable) {
      const updatedList = selectedItem.filter((item) => item?.id !== data?.id)
      setSelectedItem(updatedList)
    } else {
      if (isPreshift) {
        setSelectedItem((prev) => [...prev, data])
      } else {
        setSelectedItem([data])
      }
    }
  }

  const handlePreview = () => {
    if (onSelect) {
      onSelect(isPreshift ? selectedItem : selectedItem[0])
      onClose()
      return
    }

    if (isGenerateQuestion) {
      if (selectedItem?.length > 0) {
        const selecteditem = selectedItem.map((item) => ({
          ...item,
          category: formateString(selectedChallengeCategory.name?.toUpperCase())
        }))

        dispatch(learningDevelopmentActions.setSelectedMenuItems(selecteditem))
        onClose()
      } else {
        toast.error("Please select atleast one menu item!", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark"
        })
      }
    } else {
      const payload = {
        challenge_id: weeklyChallengeId,
        category_id: selectedChallengeCategory?.id,
        new_item_id: selectedItem?.[0].id,
        new_item_type: formateString(selectedChallengeCategory?.name?.toUpperCase()),
        platform: userRestaurant?.name
      }

      dispatch(ReplaceChallengeMenuItemAction({ payload, onClose }))
    }
  }

  useEffect(() => {
    dispatch(weeklyCategoryAction())
  }, [])

  useEffect(() => {
    if (!challengeQuestionsCount?.length && !weeklyCategoryList?.menu?.length) return
    const isCountArray = Array.isArray(challengeQuestionsCount)
    const newList =
      !isGenerateQuestion && isCountArray
        ? challengeQuestionsCount.map(({ category_id, category_name }) => ({
            id: category_id,
            name: category_name
          }))
        : weeklyCategoryList?.menu?.map(({ category_id, category_name }) => ({
            id: category_id,
            name: category_name
          }))

    setChallengeCategoryList(newList)
    setSelectedChallengeCategory(newList?.[0])
  }, [challengeQuestionsCount, weeklyCategoryList, module])

  useEffect(() => {
    const selectedCategory = weeklyCategoryList?.menu?.find(
      (cat) => cat.category_id === selectedChallengeCategory?.id
    )

    let subcategories = []

    if (selectedCategory) {
      const catName = selectedCategory.category_name

      subcategories = (selectedCategory?.items || selectedCategory?.subcategories)?.map((item) => ({
        category_id: selectedCategory.category_id,
        category_name: catName,
        subcategory_id: item.meal_period_id || item.category_id || item.subcategory_id,
        subcategory_name: item.meal_period_name || item.category_name || item.subcategory_name,
        items:
          item?.categories ||
          item?.subcategories ||
          item?.items ||
          item?.nested_nested_subcategories
      }))
    } else {
      subcategories = []
    }

    setSubCategoryList(subcategories)
    setSelectedSubCategory(subcategories?.[0])
  }, [weeklyCategoryList, selectedChallengeCategory])

  return (
    <StyledDialog open={true} maxWidth="">
      <DialogContent id="editQuestionDialog" className={styles.dialogBox}>
        <React.Fragment>
          <Box className="d-flex justify-content-center position-relative">
            <Typography variant="h2">Select Menu Item</Typography>
            <Box className={styles.closeButton}>
              <span role="button" onClick={onClose}>
                <IconButton sx={(theme) => ({ color: theme.palette.text.primary })}>
                  <CloseIcon sx={{ height: "14px", width: "14px" }} />
                </IconButton>
              </span>
            </Box>
          </Box>
          <Box height={40} />
          <Box sx={{ padding: "0 11px" }}>
            <Row className="mt-4">
              <Col lg="12">
                <CategoryNavBar
                  activeTab={selectedChallengeCategory?.id}
                  setSelectedChallengeCategory={setSelectedChallengeCategory}
                  navBarList={challengeCategoryList}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col lg="12">
                <SubCategoryNavBar
                  activeTab={selectedSubCategory}
                  setSelectedSubCategory={setSelectedSubCategory}
                  navBarList={subCategoryList}
                />
              </Col>
            </Row>
            {onGoToMenu && (
              <Box className="d-flex justify-content-end">
                <AppButton onClick={onGoToMenu} styles={{ padding: "6px 16px", fontSize: "12px" }}>
                  + Add New Items
                </AppButton>
              </Box>
            )}
            <>
              {!isGrouped ? (
                renderGroupedItems(
                  selectedSubCategory?.items || selectedSubCategory?.nested_nested_subcategories
                )
              ) : selectedSubCategory?.items?.length > 0 ? (
                <Card>{renderItemsGrid(selectedSubCategory?.items)}</Card>
              ) : null}
              {!selectedSubCategory && (
                <Box className="d-flex justify-content-center align-items-center" height={"40vh"}>
                  <Typography variant="h2">
                    {isLoading
                      ? "Please wait, we are fetching the menu items..."
                      : "No Items Found"}
                  </Typography>
                </Box>
              )}
            </>
            {selectedSubCategory && (
              <Box className="d-flex justify-content-center">
                <AppButton
                  className="mt-3 px-5"
                  variant="outlined"
                  disabled={selectedItem?.length > 0 ? false : true}
                  onClick={handlePreview}>
                  {isGenerateQuestion
                    ? "Preview Menu Item"
                    : module === "PRESHIFT"
                    ? "Add Menu Item"
                    : "Replace Menu Item"}
                </AppButton>
              </Box>
            )}
          </Box>
        </React.Fragment>
      </DialogContent>
    </StyledDialog>
  )
}

export default SelectMenuItems
